import { render, staticRenderFns } from "./account-icon.vue?vue&type=template&id=3bbf5158"
import script from "./account-icon.vue?vue&type=script&lang=js"
export * from "./account-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports